import React,{useState} from 'react';
import axios from 'axios';
import Search from './components/Search';
import Results from './components/Results';
import Popup from './components/Popup';

function App() {

  const [state, setState] = useState({
    s:"",
    results: [],
    selected:{}
  });

  const APP_ID = "fd7ea02c";
  const APP_KEY = "1c28cb7da46edc8bafd996261533b144";

  

  const api_url = `https://api.edamam.com/api/recipes/v2?type=public&imageSize=THUMBNAIL&app_id=${APP_ID}&app_key=${APP_KEY}`;

  const api_start = `https://api.edamam.com/api/recipes/v2/`;
  const api_end = `?type=public&&app_id=${APP_ID}&app_key=${APP_KEY}`;
  
 
  const search = (e) => {
    if(e.key === "Enter"){
      axios(api_url+ "&q=" + state.s).then(({ data } ) => {
        let results = data.hits;
        setState(prevState => {
          return {...prevState, results: results}
        })
      });
    }
  }
  const handleInput = (e) => {
    let s = e.target.value;

    setState(prevState => {
      return {...prevState, s: s}
    });
  }
  
  const openPopup = id => {
    axios(api_start + id + api_end).then(({data}) => {
      let result = data;
      console.log(data);
      setState(prevState => {
        return {...prevState, selected: result}
      });
    })
  }

  const closePopup = () => {
    setState(prevState => {
      return { ...prevState, selected: {} }
    });

  }

  
  return(
    
    <div className="App">
      <main className="main-container" id="blur">
        <div className="title-box">
          <h1 className="text-center">RECIPE MINE</h1>
        </div>
        <Search handleInput={handleInput} search={search}/>
        <div className="container">
          <Results results={state.results} openPopup={openPopup}/>
          {(typeof state.selected.recipe != "undefined") ? <Popup selected={state.selected} closePopup={closePopup}/>:false }
          </div>
          <div className="text-light footer">
            <a href="#">&copy; Tanmay Patil</a>
          </div>
      </main>
    </div>

  );
}
   
export default App;